export const SELECT_VENDOR_PRODUCT = 'SELECT_VENDOR_PRODUCT';
export const DESELECT_VENDOR_PRODUCT = 'DESELECT_VENDOR_PRODUCT';

